import { DateTime } from 'luxon';

export const errorMessages = {
  empty: 'Enter your date of birth.',
  incomplete: 'Date of birth must include a day, a month and a year.',
  invalid: 'Date of birth must be a real date.',
  future: 'Date of birth must be in the past.',
  tooOld: 'Date of birth must be after 1 January 1900.',
  tooYoung: 'Date of birth must be at least 5 years ago. Children under 5 are not eligible.',
};

export function getBirthdateValidationError(day, month, year) {
  if (!day && !month && !year) return errorMessages.empty;
  if (!day || !month || !year) return errorMessages.incomplete;

  const date = DateTime.fromObject({ day: Number(day), month: Number(month), year: Number(year) });

  const now = DateTime.now();
  const minDate = now.minus({ years: 5 });

  if (!date.isValid) return errorMessages.invalid;
  if (date.year < 1900) return errorMessages.tooOld;
  if (date > now) return errorMessages.future;
  if (date > minDate) return errorMessages.tooYoung;

  return '';
}

export function isBirthdateEmptyOrIncomplete(day, month, year) {
  if (!day && !month && !year) return true;
  if (!day || !month || !year) return true;
  return false;
}

const hopRegistrationDobInputIds = ['dob-day', 'dob-month', 'dob-year'];

export function clearHopRegistrationDobInputErrors() {
  hopRegistrationDobInputIds.forEach((id) => {
    document.getElementById(id)?.classList.remove('input-validation-error');
  });
}
